import { render, staticRenderFns } from "./wkUnresident.vue?vue&type=template&id=4d03eb11&scoped=true"
import script from "./wkUnresident.vue?vue&type=script&lang=js"
export * from "./wkUnresident.vue?vue&type=script&lang=js"
import style0 from "./wkUnresident.vue?vue&type=style&index=0&id=4d03eb11&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d03eb11",
  null
  
)

export default component.exports